import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-service-offering-provider-pf',
    standalone: true,
    imports: [RouterOutlet],
    templateUrl: './provider-pf.component.html'
})
export class ProviderPFComponent {}
